import { AxiosInstance } from "axios";

import { Dependencies } from "@planzone/core";

function createDocumentsHttpClient(
  session: Dependencies["session"],
  axios: AxiosInstance,
): Dependencies["httpClient"] {
  return {
    download(uri) {
      return session
        .retrieve()
        .then(({ accessToken }) =>
          axios({
            method: "GET",
            url: uri,
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
            responseType: "blob",
          }),
        )
        .then(({ data }) => ({
          uri: URL.createObjectURL(data),
          size: data.size,
          name: "",
          type: data.type,
        }));
    },
  };
}

export { createDocumentsHttpClient };
